document.addEventListener('DOMContentLoaded', function() {
  const starElements = document.querySelectorAll('.product-rating');
  const reviewContainer = document.querySelector('.jdgm-review-widget');

  if (starElements.length > 0 && reviewContainer) {
    starElements.forEach(function(starElement) {
      starElement.style.cursor = 'pointer'; 

      starElement.addEventListener('click', function(e) {
        e.preventDefault(); 
        
        reviewContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'start' 
        });
      });
    });
  }
});
